/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    'clipboard-data': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M4 11a1 1 0 112 0v1a1 1 0 11-2 0zm6-4a1 1 0 112 0v5a1 1 0 11-2 0zM7 9a1 1 0 012 0v3a1 1 0 11-2 0z"/><path pid="1" d="M4 1.5H3a2 2 0 00-2 2V14a2 2 0 002 2h10a2 2 0 002-2V3.5a2 2 0 00-2-2h-1v1h1a1 1 0 011 1V14a1 1 0 01-1 1H3a1 1 0 01-1-1V3.5a1 1 0 011-1h1z"/><path pid="2" d="M9.5 1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-3-1A1.5 1.5 0 005 1.5v1A1.5 1.5 0 006.5 4h3A1.5 1.5 0 0011 2.5v-1A1.5 1.5 0 009.5 0z"/>',
    },
});
